import { InteractionHistoryList } from '../comps/InteractionHistoryList'

export const interactionHistoryForm = (initialValues: any) => {
  return {
    key: 'INTERACTION_HISTORY_FORM',
    verticalFlex: 1,
    contentOverflow: 'auto',
    horizontalFlex: 1,
    verticalSpacing: 0,
    formItems: [
      {
        fieldName: 'interactionHistoryList',
        ComponentName: InteractionHistoryList,
        merchantId: initialValues?.entityId,
        containerHeight: '100%',
      },
    ],
    onSubmit: async () => {},
  }
}
